import {
	Box,
	Typography
} from "@mui/material";

import { ColorScheme } from "../../Themes/ColorScheme";

import { useTranslation } from "react-i18next";

export const OrderDrawerContent = ({ data }) => {

	console.log(data);
	const { t } = useTranslation();

	return (
		<Box>
			<div>

				{data !== null && (
					<Box>
						<div style={{ height: "40px" }} />

						<Typography
							sx={{
								fontSize: "12px",
								// marginTop: "50px",
								color: ColorScheme.primary
							}}
						>
								{new Date(data.created_at).toLocaleString()}
						</Typography>
						<Typography
							sx={{
								fontSize: "14px",
								marginTop: "50px",
								marginBottom: "20px",
								color: ColorScheme.primary
							}}
						>
							{t("orders.product_row_label")}
						</Typography>
						{data?.order_contents && data.order_contents.map((content, i) => (
							<Box key={i}>
								<Box
									sx={{
										my: "20px",
										flexDirection: "row",
										display: "flex",
										width: "100%",
										justifyContent: "space-between",
										alignItems: "center"
									}}
								>
									<Box>
										<Typography
											sx={{
												fontSize: "16px",
												fontWeight: "700"
											}}
										>
											{content.name}
										</Typography>
									</Box>
									<Box
										sx={{
											alignItems: "flex-end",
											display: "flex",
											flexDirection: "column",
											width: "35%"
										}}
									>
										<Typography
											sx={{
												fontSize: "16px",
												fontWeight: "700"
											}}
										>
											{content.vat_price.toFixed(2) +
												" " +
												t("common.currency_symbol")}
										</Typography>
										<Typography
											sx={{
												fontSize: "12px",
												color: ColorScheme.black
											}}
										>
											{"(" +
												content.vat_percentage +
												" %)"}
										</Typography>
									</Box>
								</Box>
								<Box
									sx={{
										height: "1px",
										width: "100%",
										backgroundColor:
											ColorScheme.primary,
										opacity: 0.2
									}}
								></Box>
							</Box>
						))}
						<Box
							sx={{
								marginTop: "50px",
								flexDirection: "row",
								alignItems: "center",
								justifyContent: "space-between",
								display: "flex"
							}}
						>
							<Typography
								sx={{
									fontSize: "16px",
									fontWeight: "700"
								}}
							>
								{t("orders.total_label")}
							</Typography>
							<Typography
								sx={{
									fontSize: "20px",
									fontWeight: "700"
								}}
							>
								{data.total_vat_price.toFixed(2) +
									" " +
									t("common.currency_symbol")}
							</Typography>
						</Box>
						<Box sx={{width: "100%", display: "flex", justifyContent: "flex-end"}}>
							{data.order_succesful && data.order_complete && data.refund_status == 0 && (
								<Typography sx={{fontSize: "16px", fontWeight: "700", color: ColorScheme.green}}>{t("orders.paid_label")}</Typography>
							)}
							{(!data.order_succesful || !data.order_complete) && data.refund_status == 0 && (
								<Typography sx={{fontSize: "16px", fontWeight: "700", color: ColorScheme.red}}>{t("orders.unpaid_label")}</Typography>
							)}
							{data.refund_status != 0 && (
								<Typography sx={{fontSize: "16px", fontWeight: "700", color: ColorScheme.grey}}>{t("orders.successful_cancel_label")}</Typography>
							)}
						</Box>
					</Box>
				)}
			</div>
		</Box>
	);
};
